import { BrandInfo } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/BrandInfo";
import { brandInfoProductTileAdaptor } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/brandInfoUtils";
import { DebugInfoSection } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/DebugInfoSection/DebugInfoSection";
import { SearchProductImageClient } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductImage/search/SearchProductImageClient";
import { PriceWithClientFormatMoney } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductInfo/PriceText/PriceWithClientFormatMoney";
import { UnlockWholesalePriceLink } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductInfo/PriceText/UnlockWholesalePriceLink";
import { ProductName } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductInfo/ProductName";
import { SearchProductLink } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductLink/SearchProductLink";
import { SearchProductTileClickProvider } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileClickProvider/search/SearchProductTileClickProvider";
import { ProductTileContainer } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileContainer/ProductTileContainer";
import { ProductTileTrackingWrapper } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileTrackingWrapper/ProductTileTrackingWrapper";
import { ProductTileUpperContainer } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileUpperContainer/ProductTileUpperContainer";
import { TopBadges } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/TopBadges/TopBadges";
import { ProductTileContextProvider } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/ProductTileContextProvider";
import { ProductTileSwatches } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/ProductTileSwatches";
import { SearchProductTileProps } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/SearchProductTileProps";
import { Spacer } from "@faire/web--source/slate/spacing";
import { IThreeVariantXP } from "@faire/web-api--source/indigofair/settings/IThreeVariantXP";
import React from "react";

export const LoggedOutSearchProductTile = ({
  data,
}: {
  data: SearchProductTileProps;
}) => {
  const {
    productTileImageProps,
    productTileTrackingWrapperProps,
    productTileDebugInfoProps,
    productTileTopBadgesProps,
    productTileClickProviderProps,
    productTile,
    brand,
    priceTextProps,
    insiderBadgeProps,
    productSearchString,
    loggedOutPriceTestVariant,
  } = data;

  const shouldShowProminentPriceVariant2 =
    loggedOutPriceTestVariant === IThreeVariantXP.Bucket.VARIANT_2;
  const shouldHidePriceProminencePriceTestV3 =
    loggedOutPriceTestVariant === IThreeVariantXP.Bucket.VARIANT_3;
  const isLoggedOutProductTilePriceTest =
    loggedOutPriceTestVariant !== IThreeVariantXP.Bucket.CONTROL;

  const token = productTile.product?.token;
  if (!token) {
    return null;
  }
  const brandInfoData = brandInfoProductTileAdaptor({
    productTile,
    productSearchString,
    brand,
    insiderBadgeProps,
    isLoggedInRetailer: false,
    isLoggedOutProductTilePriceTest,
    shouldHidePriceProminencePriceTestV3,
  });

  return (
    <ProductTileContextProvider brandToken={brand?.token} brand={brand}>
      <ProductTileTrackingWrapper data={productTileTrackingWrapperProps}>
        <SearchProductTileClickProvider data={productTileClickProviderProps}>
          <ProductTileContainer>
            <ProductTileUpperContainer>
              <SearchProductLink data={productTileClickProviderProps}>
                <SearchProductImageClient data={productTileImageProps} />
              </SearchProductLink>
              <TopBadges data={productTileTopBadgesProps} />
              <DebugInfoSection data={productTileDebugInfoProps} />
            </ProductTileUpperContainer>
            <Spacer size={{ mobileAndAbove: "1x", tabletAndAbove: 12 }} />
            <SearchProductLink data={productTileClickProviderProps}>
              {shouldShowProminentPriceVariant2 ? (
                <PriceWithClientFormatMoney
                  {...priceTextProps}
                  shouldShowProminentPriceVariant2
                  shouldHidePriceProminencePriceTestV3={false}
                />
              ) : null}
              <ProductName
                productName={productTile?.product?.name ?? ""}
                shouldShowProminentPriceVariant2={
                  shouldShowProminentPriceVariant2
                }
              />
              {shouldShowProminentPriceVariant2 ? null : (
                <PriceWithClientFormatMoney
                  {...priceTextProps}
                  shouldShowProminentPriceVariant2={false}
                  shouldHidePriceProminencePriceTestV3={
                    shouldHidePriceProminencePriceTestV3
                  }
                />
              )}
              <ProductTileSwatches
                optionDetails={productTile.options_details}
              />
            </SearchProductLink>
            {shouldShowProminentPriceVariant2 ? <Spacer size={6} /> : null}
            <BrandInfo data={brandInfoData} />
            {shouldHidePriceProminencePriceTestV3 ? (
              <SearchProductLink data={productTileClickProviderProps}>
                <UnlockWholesalePriceLink />
              </SearchProductLink>
            ) : null}
          </ProductTileContainer>
        </SearchProductTileClickProvider>
      </ProductTileTrackingWrapper>
    </ProductTileContextProvider>
  );
};
